import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios_config";
import { handleRejectedResponse } from './utils';
import { notification } from "antd";

export const CreateVendorItems = createAsyncThunk(
  'vendorItem/createVendorItem',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/vendor-items/create-vendor-item`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Create Vendor Item', rejectWithValue);
    }
  }
);

export const CreateNewVendorItem = createAsyncThunk(
  'vendorItem/createNewVendorItem',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/vendor-items/create-new-vendor-item`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Create Vendor Item', rejectWithValue);
    }
  }
);

export const GetVendorItems = createAsyncThunk(
  'vendorItem/getVendorItems',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/vendor-items/get-specific-vendor-items`, {
        params: data
      }
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Vendor Item', rejectWithValue);
    }
  }
);

export const EditVendorItemInfo = createAsyncThunk(
  'vendorItem/editVendorItemInfo',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${process.env.OPULENT_NODE_API_URL}/vendor-items/edit-vendor-item`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Edit Vendor Item', rejectWithValue);
    }
  }
);

export const LinkVendorItem = createAsyncThunk(
  'vendorItem/linkVendorItem',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${process.env.OPULENT_NODE_API_URL}/vendor-items/link-vendor-item`,
        data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Link Vendor Item', rejectWithValue);
    }
  }
);

export const UnlinkVendorItem = createAsyncThunk(
  'vendorItem/unlinkVendorItem',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${process.env.OPULENT_NODE_API_URL}/vendor-items/unlink-vendor-item`, data
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Unlink Vendor Item', rejectWithValue);
    }
  }
);

const vendorItems = createSlice({
  name: "vendorItems",
  initialState: {
    createVendorItemLoading: false,
    getVendorItemsLoading: false,
    editVendorItemLoading: false,
    linkVendorItemLoading: false,
    unlinkVendorItemLoading: false,
    createNewVendorItemLoading: false,
    success: false,
    vendorItems: [],
    message: ''
  },
  reducers: {
    ClearVendorItemStates(state, { payload: { field, value } }) {
      state[field] = value;
    },
  },
  extraReducers: {
    [CreateVendorItems.pending]: (state, action) => ({
      ...state,
      createVendorItemLoading: true
    }),
    [CreateVendorItems.fulfilled]: (state, action) => {
      const { message, success } = action?.payload?.data || {};
      notification['success']({
        message: 'Vendor Item Created Successfully',
        top: 65,
      });
      return {
        ...state,
        createVendorItemLoading: false,
        message,
        success
      }
    },
    [CreateVendorItems.rejected]: (state, action) => {
      return {
        ...state,
        createVendorItemLoading: false
      }
    },
    [GetVendorItems.pending]: (state, action) => ({
      ...state,
      getVendorItemsLoading: true
    }),
    [GetVendorItems.fulfilled]: (state, action) => {
      const { message, success, vendorItems } = action?.payload || {};
      return {
        ...state,
        getVendorItemsLoading: false,
        vendorItems,
        message,
        success
      }
    },
    [GetVendorItems.rejected]: (state, action) => {
      return {
        ...state,
        getVendorItemsLoading: false
      }
    },
    [EditVendorItemInfo.pending]: (state, action) => ({
      ...state,
      editVendorItemLoading: true
    }),
    [EditVendorItemInfo.fulfilled]: (state, action) => {
      const { message, success } = action?.payload?.data || {};
      notification['success']({
        message: 'Vendor Item Updated Successfully',
        top: 65,
      });
      return {
        ...state,
        editVendorItemLoading: false,
        message,
        success
      }
    },
    [EditVendorItemInfo.rejected]: (state, action) => {
      return {
        ...state,
        editVendorItemLoading: false
      }
    },
    [LinkVendorItem.pending]: (state, action) => ({
      ...state,
      linkVendorItemLoading: true
    }),
    [LinkVendorItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload?.data || {};
      notification['success']({
        message: 'Vendor Item Linked Successfully',
        top: 65,
      });
      return {
        ...state,
        linkVendorItemLoading: false,
        message,
        success
      }
    },
    [LinkVendorItem.rejected]: (state, action) => {
      return {
        ...state,
        linkVendorItemLoading: false
      }
    },
    [UnlinkVendorItem.pending]: (state, action) => ({
      ...state,
      unlinkVendorItemLoading: true
    }),
    [UnlinkVendorItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload?.data || {};
      notification['success']({
        message: 'Vendor Item Unlinked Successfully',
        top: 65,
      });
      return {
        ...state,
        unlinkVendorItemLoading: false,
        message,
        success
      }
    },
    [UnlinkVendorItem.rejected]: (state, action) => {
      return {
        ...state,
        unlinkVendorItemLoading: false
      }
    },
    [CreateNewVendorItem.pending]: (state, action) => ({
      ...state,
      createNewVendorItemLoading: true
    }),
    [CreateNewVendorItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload?.data || {};
      notification['success']({
        message: 'New Vendor Item Created Successfully',
        top: 65,
      });
      return {
        ...state,
        createNewVendorItemLoading: false,
        message,
        success
      }
    },
    [CreateNewVendorItem.rejected]: (state, action) => {
      return {
        ...state,
        createNewVendorItemLoading: false
      }
    },
  },
});

const { reducer, actions } = vendorItems;

export const {
  ClearVendorItemStates
} = actions;

export default reducer;
